import { GridColumnMenu, GridColumnMenuProps } from '@mui/x-data-grid-premium';
import React from 'react';
import {
    KEY_CREDITS_COLUMN_MENU_WRAP_LIMIT_ORDER,
    KeyCreditsColumnMenuWrapLimitItem,
    type KeyCreditsWrapLimit,
    isKeyCreditsColumnField
} from '../../keyCredits';

/**
 * Reusable column menu that shows ONLY wrap limit control.
 * Used for columns that need multi-line text with configurable line limits.
 */
export interface WrapLimitColumnMenuProps extends GridColumnMenuProps {
    wrapLimitColumnNames: string[];
    wrapLimit: Record<string, KeyCreditsWrapLimit>;
    onWrapLimitChange: (field: string, value: KeyCreditsWrapLimit) => void;
}

export default function WrapLimitColumnMenu({
    wrapLimitColumnNames,
    wrapLimit,
    onWrapLimitChange,
    ...props
}: WrapLimitColumnMenuProps) {
    const fieldName = props.colDef?.field ?? '';
    const isWrapLimitColumn = isKeyCreditsColumnField(fieldName, wrapLimitColumnNames);

    return (
        <GridColumnMenu
            {...props}
            slots={
                isWrapLimitColumn
                    ? {
                          columnMenuKeyCreditsWrapLimitItem: KeyCreditsColumnMenuWrapLimitItem
                      }
                    : undefined
            }
            slotProps={
                isWrapLimitColumn
                    ? {
                          columnMenuKeyCreditsWrapLimitItem: {
                              displayOrder: KEY_CREDITS_COLUMN_MENU_WRAP_LIMIT_ORDER,
                              // KeyCreditsColumnMenuWrapLimitItem uses `displayModeColumnNames` as its allow-list prop
                              displayModeColumnNames: wrapLimitColumnNames,
                              displayMode: {},
                              wrapLimit,
                              onWrapLimitChange
                          }
                      }
                    : undefined
            }
        />
    );
}
